export default (Alpine) => {

	Alpine.data('dropdown', (id, delay = 1000) => ({

		// No activeMenu here, it needs to go on a parent element to ensure only one element stays open at a time
		timeout: null,
		parent: {

			['@mouseleave']() { this.close() },
			['@click.outside']() { this.forceClose() },
			['@keydown.escape.window']() { this.forceClose() }

        },
        trigger: {

			['href']: '#',
			['role']: 'button',
			[':aria-expanded']() { return this.open },
			['aria-haspopup']: 'true',
			['@click.prevent.stop']() { this.toggle() },
			['@keydown.enter.prevent']() { this.toggle() },
			['@keydown.space.prevent']() { this.toggle() },
			['@focus']() { 

				if (event.target.matches(':focus-visible')) this.show() 

			}

        },
        child: {

			['@mouseenter']() { this.show() },
			['x-show']() { return this.open },
			['x-cloak']: true,
			['role']: 'menu',
			['x-auto-transition:enter']: 'alpine-fade',
			['@focusout']() { 

				if (!this.$el.contains(event.relatedTarget)) this.close() 

			}

        },
		get open() { 
			
			return this.activeMenu === id;
			
		},
		toggle() {

			this.activeMenu = this.open ? null : id;

		},
		show() {

			if (this.timeout) {
				
				clearTimeout(this.timeout);

			}

			this.activeMenu = id;

		},
		close() {

			if (this.timeout) {
				
				clearTimeout(this.timeout);

			}

			this.timeout = setTimeout(() => {

				if (this.activeMenu === id) {
					
					this.activeMenu = null;

				}

			}, delay);

		},
		forceClose() {

			if (this.timeout) {
				
				clearTimeout(this.timeout);

			}

			this.activeMenu = null;
			
		}

	}));

};